
export class ItemPictureModule {
  inItemPictureID: number =0 ;
  inItemID?: number = 0;
  path?: string = '';
}
